import { render, staticRenderFns } from "./TankDemandItems.vue?vue&type=template&id=9b2fa208&scoped=true&"
import script from "./TankDemandItems.vue?vue&type=script&lang=js&"
export * from "./TankDemandItems.vue?vue&type=script&lang=js&"
import style0 from "./TankDemandItems.vue?vue&type=style&index=0&id=9b2fa208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2fa208",
  null
  
)

export default component.exports